import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Text } from "../../../../../components/Text";
import { TaskPriority } from "../../../../../model/task/types/TaskPriority.enum";
import { ThemeType } from "../../../../../theme/Theme";
import { Rounded } from "../../../../../theme/Rounded";
import { Spacing } from "../../../../../theme/Spacing";
import { getTaskPriorityColor } from "../../../../../utils/taskUtils";

/** Same height as WACommentResolvedChip, which sits beside it */
export const WA_COMMENT_CHIP_HEIGHT = "1.5rem";

const Tag = styled.span<{ $color: keyof ThemeType }>`
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: ${WA_COMMENT_CHIP_HEIGHT};
  padding: 0 ${Spacing.s};
  border-radius: ${Rounded.pill};
  border: 1px solid ${({ theme, $color }) => theme[$color]};
  white-space: nowrap;
`;

type Props = {
  priority?: TaskPriority;
};

export const WACommentPriorityTag: React.FC<Props> = ({ priority }) => {
  const { t } = useTranslation();

  const level = priority || TaskPriority.LOW;
  const color = getTaskPriorityColor(level) as keyof ThemeType;

  return (
    <Tag $color={color}>
      <Text fontSize="xs" color={color}>
        {t(`common.${level.toLowerCase()}`)}
      </Text>
    </Tag>
  );
};
